import React, { useState, useRef } from 'react';
import c from './userInitials.module.scss';
import UserInitialsContent from './UserInitialsContent';
import UserInitialsTrigger from './UserInitialsTrigger';
import { useUserMenuAvatar } from './hooks/use-user-menu-avatar';
import { useUserMenuProfile } from './hooks/use-user-menu-profile';

export const USER_INITIALS_TRIGGER_ID = 'user-initials-trigger';

const UserInitials = ({
  align = 'right',
  getData = false,
  avatarData,
  profileData,
  children,
  buttonProps,
  menuProps,
  ...restProps
}) => {
  const triggerRef = useRef(null);
  const [shown, setShown] = useState(false);
  const TITLE = 'User menu';

  const { avatarSrc, avatarAlt } = useUserMenuAvatar({
    avatarData,
    getData,
  });

  const { name, email, id, pronouns } = useUserMenuProfile({
    profileData,
    getData,
  });

  const handleTriggerOnClick = () => {
    setShown((prevShown) => !prevShown);
  };

  return (
    <div id="userInitials" className={c.container} {...restProps}>
      <UserInitialsTrigger
        triggerRef={triggerRef}
        title={TITLE}
        onClick={handleTriggerOnClick}
        avatarSrc={avatarSrc}
        {...buttonProps}
      />
      <UserInitialsContent
        triggerRef={triggerRef}
        title={TITLE}
        shown={shown}
        setShown={setShown}
        align={align}
        avatarSrc={avatarSrc}
        avatarAlt={avatarAlt}
        name={name}
        email={email}
        id={id}
        pronouns={pronouns}
        {...menuProps}
      >
        {children}
      </UserInitialsContent>
    </div>
  );
};

export default UserInitials;
